import React from "react";
import AttributesListTableComponent from './attributesListTable.component';
import {useSelector} from "react-redux";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../lib/constants/accessRights";

export default function AttributesListTableContainer({
  hasProductAttributeEditAccessRight,
  hasProductAttributeDeleteAccessRight,
  isSelectAll,
  selectedIds,
  paginationOptions,
  data,
  isFetching,
  isLoadingAttributeListError,
  handleChangePage,
  handleChangeRowsPerPage,
  handleReload,
  page,
  search,
  totalFiltered,
  rowsPerPage,
  handleCreateAttribute,
  handleChangeStatus,
  handleSelectAttribute,
  handleSelectAvailable,
  handleSelectAll,
  handleDeselectAll,
  handleDeleteAttribute,
  handleEditAttribute,
  lang
}) {
  const canEditStatus = useSelector(state => canAccess(state, AccessRights.Product.BRAND_MODEL_UPDATE_STATUS));

  return (
    <AttributesListTableComponent
      hasProductAttributeEditAccessRight={hasProductAttributeEditAccessRight}
      hasProductAttributeDeleteAccessRight={hasProductAttributeDeleteAccessRight}
      canEditStatus={canEditStatus}
      isSelectAll={isSelectAll}
      selectedIds={selectedIds}
      paginationOptions={paginationOptions}
      data={data}
      isFetching={isFetching}
      isLoadingAttributesListError={isLoadingAttributeListError}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      handleReload={handleReload}
      page={page}
      rowsPerPage={rowsPerPage}
      search={search}
      totalFiltered={totalFiltered}
      handleCreateAttribute={handleCreateAttribute}
      handleChangeStatus={handleChangeStatus}
      handleSelectAttribute={handleSelectAttribute}
      handleSelectAvailable={handleSelectAvailable}
      handleSelectAll={handleSelectAll}
      handleDeselectAll={handleDeselectAll}
      handleDeleteAttribute={handleDeleteAttribute}
      handleEditAttribute={handleEditAttribute}
      lang={lang}
    />
  )
}
